module.exports = __webpack_public_path__ + "img/activity_3_1.35d59eec.png";